import schema, {
  AGENT_AGENT,
  AGENT_FIRST_NAME,
  AGUI_EXPERIENCE_AGENT_CONSOLE,
  AGUI_EXPERIENCE_AGENT_WORKSPACE,
  AGUI_EXPERIENCE_TOGGLE,
  PHONE_ON_DEMAND,
  PHONE_PERSISTENT,
} from "@/react/features/vcc/agent-groups/schema";
import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema/schemaFields";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { darTimeoutOptionsList } from "@/react/features/vcc/agent-groups/utils/darTimeoutOptions";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      { ...getColumnDef(schema.fields.id, "ID"), type: TYPES.ID, size: 70 },
      {
        ...getColumnDef(schema.fields.name, "Group Name"),
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      { ...getColumnDef(schema.fields.comment, "Comment"), editable: true },
      {
        ...getColumnDef(schema.fields.agent_count, "# of Agents"),
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          schema.fields.outbound_phone_code_list.fields.name,
          "Assigned OutPhone List"
        ),
      },
      {
        ...getColumnDef(
          schema.fields.agent_recordings_enabled,
          "My Recordings Enabled"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.resolved_display_customer_cli_enabled,
          "Display Customer CLI"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.default_agent_display_name,
          "Default Agent Display Name"
        ),
        type: TYPES.SELECT,
        options: {
          [AGENT_FIRST_NAME]: "First Name",
          [AGENT_AGENT]: "Agent",
        },
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.edit_agent_display_name_enabled,
          "Editable Agent Display Name"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.agent_reject_enabled,
          "Agent Reject Enabled"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.auto_answer_enabled,
          "Auto Answer Enabled"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.phone_connection_mode,
          "Phone Connection Mode"
        ),
        type: TYPES.SELECT,
        options: {
          [PHONE_ON_DEMAND]: "On Demand",
          [PHONE_PERSISTENT]: "Persistent",
        },
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.change_phone_connection_mode,
          "Change Phone Connection Mode"
        ),
        type: TYPES.BOOLEAN,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.status_code_list.fields.name,
          "Status Code List"
        ),
      },
      {
        ...getColumnDef(schema.fields.is_assigned, "Is Assigned"),
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(schema.fields.is_default, "Set As Default"),
        type: TYPES.BOOLEAN,
        // editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.dar_timeout,
          "DAR Post Processing Timeout"
        ),
        type: TYPES.SELECT,
        options: darTimeoutOptionsList.reduce(
          (acc, { value, label }) => ({
            ...acc,
            [value]: label,
          }),
          {}
        ),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.agui_mode, "Experience"),
        type: TYPES.SELECT,
        options: {
          [AGUI_EXPERIENCE_AGENT_CONSOLE]: "Agent Console",
          [AGUI_EXPERIENCE_AGENT_WORKSPACE]: "Agent Workspace",
          [AGUI_EXPERIENCE_TOGGLE]: "Flexible",
        },
        // editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
